import { render, staticRenderFns } from "./IbanBuyer.vue?vue&type=template&id=067d947e&"
import script from "./IbanBuyer.vue?vue&type=script&lang=js&"
export * from "./IbanBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IbanBuyer.vue"
export default component.exports